import React, { Component } from 'react'
import CircularProgress from 'material-ui/CircularProgress'
import { AssetUploaderSource } from 'sources'
import Dropzone from 'react-dropzone'
import { Button, HelpEmail, Notice } from 'components'

import './assetUploader.scss'

const ALLOWED_EXTENSIONS = "PNG"
const ALLOWED_MIME_TYPES = "image/png"
const MAX_SIZE_BYTES = 3e+6
const MAX_SIZE_HUMAN = "3MB"

export default class AssetUploader extends Component {
  static propTypes = {
    filename: React.PropTypes.string.isRequired,
    label: React.PropTypes.string.isRequired,
    url: React.PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      imageFile: null,
      errorHeader: null,
      errorBody: null,
      url: this.props.url,
      isUploading: false
    }

    this.handleAssetDrop = this.handleAssetDrop.bind(this)
    this.handleRemoveAsset = this.handleRemoveAsset.bind(this)
    this.uploadAsset = this.uploadAsset.bind(this)
    this.deleteAsset = this.deleteAsset.bind(this)
  }

  handleAssetDrop(imageFile, rejectedFiles) {
    if (rejectedFiles.length > 0) {
      this.setState({
        errorHeader: "Can't upload image",
        errorBody: <div>This image cannot be uploaded because it is larger than {MAX_SIZE_HUMAN} or is not a {ALLOWED_EXTENSIONS}</div>
      })
      return
    }
    
    imageFile = imageFile[0]
    let url = imageFile.preview
    this.setState({ imageFile, url }, this.uploadAsset)
  }

  uploadAsset() {
    this.setState({ isUploading: true, errorHeader: null, errorBody: null }, () => {
      AssetUploaderSource
        .upload(this.state.imageFile, this.props.filename)
        .then(this.props.afterUpload)
        .catch(() => {
          this.setState({
            errorHeader: 'Failed to upload the image.',
            errorBody: <div>Please <a onClick={this.uploadAsset}>try again</a>. If the failure continues email us at <HelpEmail />, we'd be happy to help.</div>
          })
        })
        .finally(() => this.setState({ isUploading: false }))
    })
  }

  deleteAsset() {
    this.setState({ isUploading: true }, () => {
      AssetUploaderSource
      .delete(this.props.filename)
      .then(() => {
        this.setState({ imageFile: null, url: null })
        this.props.afterDelete()
      })
      .catch(() => {
        this.setState({
          errorHeader: 'Failed to remove the image.',
          errorBody: <div>Please <a onClick={this.deleteAsset}>try again</a>. If the failure continues email us at <HelpEmail />, we'd be happy to help.</div>
        })
      })
      .finally(() => this.setState({ isUploading: false }))
    })
  }

  handleRemoveAsset() {
    this.deleteAsset()
  }

  renderError() {
    return (
      <Notice error header={ this.state.errorHeader }>
        { this.state.errorBody }
      </Notice>
    )
  }

  render() {
    let imageFragment
    if (this.state.isUploading || this.props.processing) {
      return (
        <div className="logo-uploader__logo-upload-container">
          <CircularProgress size={60} thickness={5} />
        </div>
      );
    }

    if (this.state.url) {
      imageFragment = (
        <div>
          <div className="logo-uploader__logo-upload-container">
            <img className="logo-uploader__uploaded-image" src={this.state.url} />
          </div>
          <Dropzone
            maxSize={MAX_SIZE_BYTES}
            accept={ALLOWED_MIME_TYPES}
            className="logo-uploader__dropzone-change"
            onDrop={this.handleAssetDrop}>
            <a className="body2 logo-uploader__change-btn">Change</a>
          </Dropzone>
          <a className="body2" onTouchTap={this.handleRemoveAsset}>Remove</a>
        </div>
      )
    } else {
      imageFragment = (
        <div className="logo-uploader__logo-upload-container">
          <Dropzone
            className="logo-uploader__dropzone"
            maxSize={MAX_SIZE_BYTES}
            accept={ALLOWED_MIME_TYPES}
            onDrop={this.handleAssetDrop}>
            <Button 
              label={this.props.label}
              buttonType="secondary"
            />
          </Dropzone>
        </div>
      )
    }

    return (
      <div>
        {imageFragment}
        <p className="body2 asset-uploader__asset-requirements">Maximum Size: {MAX_SIZE_HUMAN}</p>
        <p className="body2 asset-uploader__asset-requirements">Accepted Formats: {ALLOWED_EXTENSIONS}</p>
        { this.state.errorHeader && this.renderError() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/AssetUploader.js